<template lang="pug">
#search
  .sort(v-if="projects && projects.length")
    md-field(md-theme="white")
      md-select(v-model="filter.project_id" @md-selected="changeFilter")
        md-option(value="all") Проект: Все
        md-option(v-for="project in projects" v-bind:value="project.id" v-bind:key="project.id") {{project.name}}
  .sort(v-if="statuses && statuses.length")
    md-field(md-theme="white")
      md-select(v-model="filter.status_id" @md-selected="changeFilter")
        md-option(value="all") Статус: Все
        md-option(v-for="status in statuses" v-bind:value="status.id" v-bind:key="status.id") {{status.name}}

  md-chip.small.md-primary.user-label(v-if="userFilter && userFilter.id" v-on:click="clearUser") {{ (userFilter.fio) ? userFilter.fio : userFilter.login }}
  input.text(v-if="!userFilter || !userFilter.id" type="text" placeholder="Ответственный" v-model="searchStringUser" @keyup="dropdown")
  ul.dropdown.md-elevation-1(v-if="showSearchDropdown && searchStringUser")
    li(@click="filterUser(user)" v-for="user in users") Исполнитель #[md-chip {{ (user.fio) ? (user.fio + ' (' + user.login + ')') : user.login }}]

  input.text(type="text" placeholder="Поиск..." v-model="searchString" @keyup.enter="doFilter")

  md-button.small.md-icon-button.close.md-dense.md-accent(@click="resetFilter" v-if="searchString.length"): md-icon close
  //md-button.button-close.small.md-icon-button.md-accent(@click="resetFilter" v-if="searchString.length"): md-icon close
  //md-button.md-icon-button.md-dense.md-primary(v-on:click="toggleFilterSettings")
      md-icon settings
  //.dropdown.md-elevation-2(v-if="filterSettings")
    .search-md-menu-container
      .md-layout.filter-container
        .md-layout-item.md-size-50
          .heading Группировать
          .md-layout.md-list
            .option(v-bind:class="{ active: groupBy == 'projects' }"  @click="doGroupBy('projects')" v-if="typeof $route.params.projectid == 'undefined' || $route.params.projectid == 'all'") По проекту
            .option(v-bind:class="{ active: groupBy == 'statuses' }"  @click="doGroupBy('statuses')" v-if="typeof $route.params.projectid != 'undefined' && $route.params.projectid != 'all'") По категории
            .option(v-bind:class="{ active: groupBy == 'deadline' }"  @click="doGroupBy('deadline')") По дате
            .option(v-bind:class="{ active: groupBy == 'taskmaster'}" @click="doGroupBy('taskmaster')") По создателю
        .md-layout-item.md-size-50
          .heading Сортировать
          .md-layout.md-list
            .option(v-bind:class="{ active: orderBy == 'created_at' }" @click="doOrderBy('created_at')") По дате создания
            .option(v-bind:class="{ active: orderBy == 'deadline' }"   @click="doOrderBy('deadline')") По крайнему сроку
            .option(v-bind:class="{ active: orderBy == 'name' }"       @click="doOrderBy('name')") По названию
</template>

<script>
import ToggleMenu from '@/components/ToggleMenu'

export default {
  components: {
    ToggleMenu
  },
  data() {
    return {
      searchString: '',
      searchStringUser: '',
      showSearchDropdown: false,
      users: [],
      userFilter: {},
      projects: [],
      statuses: [],
      filter: {
        project_id: 'all',
        status_id: 'all',
        responsible_id: null,
        search: null
      }
    }
  },
  metaInfo() {
    return {
      title: this.title
    }
  },
  computed: {
    groupBy() {
      return this.$store.state.tasks.groupBy
    },
    orderBy() {
      return this.$store.state.tasks.orderBy
    },
    filterStatus() {
      return this.$store.state.tasks.filterStatus
    },
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.getProjects();
        let user = localStorage.getItem('task-filter-user');
        if (user) this.userFilter = JSON.parse(user);

        let filter = localStorage.getItem('task-filter');
        if (filter) {
          filter = JSON.parse(filter);
          this.filter = {
            project_id: (filter.project_id) ? filter.project_id : 'all',
            status_id:  (filter.status_id)  ? filter.status_id  : 'all',
            responsible_id: (filter.responsible_id) ? filter.responsible_id  : null,
            search:         (filter.search)         ? filter.search          : null,
          };
          this.searchString = (filter.search) ? filter.search : '';
        }
      });
    },
    clearUser() {
      this.userFilter = {};
      localStorage.removeItem('task-filter-user');
      this.filter.responsible_id = null;
      this.changeFilter();
    },
    //фильтр по названию задачи
    doFilter() {
      if (this.searchString && this.searchString.length >= 3) {
        this.filter.search = this.searchString;
        this.changeFilter();
      }
      if (!this.searchString || this.searchString.length == 0) {
        this.filter.search = null;
        this.changeFilter()
      }
      /*
      if (this.showSearchDropdown) {
        this.showSearchDropdown = false
        if (this.$route.params.taskid) this.$router.push({ name: 'Task', params: {taskid: this.$route.params.taskid }, query: { search: this.searchStrin, project_id: this.$route.params.projectid }})
        else this.$router.push({ name: 'Tasks', query: { search: this.searchString, project_id: this.$route.params.projectid }})
      }
      */
    },
    changeFilter() {
      if (!this.filter.project_id || this.filter.project_id == 'all') this.filter.status_id = 'all';
      let filter = {
        project_id: (this.filter.project_id && this.filter.project_id != 'all') ? this.filter.project_id : null,
        status_id:  (this.filter.status_id  && this.filter.status_id  != 'all') ? this.filter.status_id  : null,
        responsible_id: (this.filter.responsible_id) ? this.filter.responsible_id  : null,
        search:         (this.filter.search)         ? this.filter.search          : null,
      };
      localStorage.setItem('task-filter', JSON.stringify(filter));
      this.$root.$emit('tasks-filter', filter);
    },
    getStatuses() {
      this.$store.dispatch('tasks/getTaskStatuses', {project_id: this.filter.project_id}).then(r => {
          if (r && r.length) this.statuses = Object.assign([], r);
          else this.statuses = [];
      });
    },
    //фильтр по исполнителю
    filterUser(user) {
      if (this.showSearchDropdown) {
        this.showSearchDropdown = false
        this.userFilter = Object.assign({}, user);
        this.filter.responsible_id = user.id;
        localStorage.setItem('task-filter-user', JSON.stringify(user));
        this.changeFilter();
        //if (this.$route.params.taskid) this.$router.push({ name: 'Task', params: {taskid: this.$route.params.taskid }, query: { responsible_id: user.id, project_id: this.$route.params.projectid}})
        //else this.$router.push({ name: 'Tasks', query: { responsible_id: user.id, project_id: this.$route.params.projectid }})
      }
    },
    //сброс фильтра
    resetFilter() {
      this.filter = {
        project_id: 'all',
        status_id: 'all',
        responsible_id: null,
        search: null
      };
      this.searchString = '';
      this.changeFilter();
    },
    //выпадашка фильтра
    dropdown() {
      if (this.searchStringUser.length < 4) return;
      this.showSearchDropdown = true
      this.$store.dispatch('users/searchUsers', {
            filter: {
              model: [
                ['email', '%', this.searchStringUser], 'or',
                ['login', '%', this.searchStringUser], 'or',
                ['fio',   '%', this.searchStringUser]
              ]
            }
          }).then(users => {
        this.users = users
      });
    },
    getProjects() {
      return this.$store.dispatch('tasks/getProjects').then(r => {
        if (r && r.length) this.projects = Object.assign([], r);
      });
    }
  },
  watch: {
    'filter.project_id'() {
      this.getStatuses();
    },
  },
  created() {
    this.init();
  },
}
</script>
<style lang="sass">
  #search
    .user-label
      flex-shrink: 0
</style>


// WEBPACK FOOTER //
// SearchToolbar.vue?eeaba62a